var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/compose/containers/warning-container.tsx";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { useAppSelector, useCompose } from 'soapbox/hooks';
import Warning from '../components/warning';
const APPROX_HASHTAG_RE = /(?:^|[^\/\)\w])#(\w*[a-zA-Z·]\w*)/i;

const WarningWrapper = _ref => {
  let {
    composeId
  } = _ref;
  const compose = useCompose(composeId);
  const me = useAppSelector(state => state.me);
  const needsLockWarning = useAppSelector(state => compose.privacy === 'private' && !state.accounts.get(me).locked);
  const hashtagWarning = compose.privacy !== 'public' && APPROX_HASHTAG_RE.test(compose.text);
  const directMessageWarning = compose.privacy === 'direct';

  if (needsLockWarning) {
    return /*#__PURE__*/React.createElement(Warning, {
      message: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "compose_form.lock_disclaimer",
        defaultMessage: "Your account is not {locked}. Anyone can follow you to view your follower-only posts.",
        values: {
          locked: /*#__PURE__*/React.createElement(Link, {
            to: "/settings/profile",
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 25,
              columnNumber: 203
            }
          }, /*#__PURE__*/React.createElement(FormattedMessage, {
            id: "compose_form.lock_disclaimer.lock",
            defaultMessage: "locked",
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 25,
              columnNumber: 232
            }
          }))
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 25,
          columnNumber: 30
        }
      }),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 25,
        columnNumber: 12
      }
    });
  }

  if (hashtagWarning) {
    return /*#__PURE__*/React.createElement(Warning, {
      message: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "compose_form.hashtag_warning",
        defaultMessage: "This post won't be listed under any hashtag as it is unlisted. Only public posts can be searched by hashtag.",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 29,
          columnNumber: 30
        }
      }),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 29,
        columnNumber: 12
      }
    });
  }

  if (directMessageWarning) {
    const message = /*#__PURE__*/React.createElement("span", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 34,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "compose_form.direct_message_warning",
      defaultMessage: "This post will only be sent to the mentioned users.",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 35,
        columnNumber: 9
      }
    }));
    return /*#__PURE__*/React.createElement(Warning, {
      message: message,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 40,
        columnNumber: 12
      }
    });
  }

  return null;
};

export default WarningWrapper;